export default __webpack_public_path__ + "static/media/9a5bb4bf5aec3053e3581c41b16b2f421599579368856.1fbefda2.webp";